import { EffectFade, Mousewheel, Navigation, Pagination, Parallax } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import 'swiper/css/effect-fade';
import { useRouter } from "next/router";
import { forwardRef, useContext, useEffect, useState } from "react"
import AboutCard from "./AboutCard";
import { isMobileContext } from "../../contexts/isMobileContext";
import Magnitizer from "../Animations/Magnitizer";
import FadeIn from "../Animations/FadeIn";
// eslint-disable-next-line react/display-name
const PhaseOverview = forwardRef(({ title, description, usps, showSection, commercialPage }, ref) => {
  const { isMobile } = useContext(isMobileContext)
  const { locale } = useRouter();
  const [previousDirection, setPreviousDirection] = useState(false);
  const [slides, setSlides] = useState(0)
  const [prevSlide, setprevSlide] = useState(-1)
  const [canClick, setCanClick] = useState(false)
  const [slideNumber, setSlideNumber] = useState(1);
  const nextSlides = () => {
    setCanClick(false)
    if (slides != usps.length - 1) {
      setSlideNumber(slideNumber + 1);
      setSlides(slides + 1)
      setprevSlide(prevSlide + 1)

    }
  }
  const prevSlides = () => {
    setCanClick(false)
    if (slides != 0) {
      setSlideNumber(slideNumber - 1);
      setSlides(slides - 1)
      setprevSlide(prevSlide - 1)
    }
  }
  return (
    <div className={`phase-overview ${!showSection ? "" : "no-padding-top"} ${commercialPage && "commercialPage"}`} ref={ref}>
      {!showSection && <FadeIn customClass="header">
        <h3 className="light _eleX">{title}</h3>
        <p className="_eleX">{description}</p>
      </FadeIn>}
      <div className="overview-swiper">
        {usps?.map((card, index) => (
          <AboutCard header={card} index={index} key={index} slides={slides} prevSlide={prevSlide} setCanClick={setCanClick} />
        ))}
        {usps?.length > 1 && <div className="swiper-navigation-continer">
          <div className="navigation-container">
            <div className="slide-number-container bold">
              <div>{slideNumber.toLocaleString('en-US', { minimumIntegerDigits: 2 })}</div>
              <div>{usps?.length.toLocaleString('en-US', { minimumIntegerDigits: 2 })}</div>
            </div>
            <progress id="file" value={slideNumber} max={usps?.length}></progress>
          </div>
          <div className="arrows-container">
            <Magnitizer dataDest={1.5}>
              <div className={`${slides == 0 && "swiper-button-disabled"} swiper-button-prev swiper-button-prev-about about-arrow black-arrow-prev`}
                onClick={() => {
                  canClick && prevSlides();
                }}
              ></div>
            </Magnitizer>
            <Magnitizer dataDest={1.5}>
              <div className={`${slides == usps?.length - 1 && "swiper-button-disabled"} swiper-button-next swiper-button-next-about  about-arrow black-arrow-next`}
                onClick={() => {
                  canClick && nextSlides();
                }}
              ></div>
            </Magnitizer>
          </div>
        </div>
        }
      </div>
    </div>
  )
})

export default PhaseOverview